import { render, staticRenderFns } from "./ArtistAnalyst.vue?vue&type=template&id=13c012e0&scoped=true&"
import script from "./ArtistAnalyst.vue?vue&type=script&lang=js&"
export * from "./ArtistAnalyst.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=13c012e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c012e0",
  null
  
)

export default component.exports